import { KatalisTranslation } from '../translations.interface';
import comum from './pt-comum.translation';
import pages from './pt-pages.translation';
import routes from './pt-routes.translation';
import enums from './pt-enums.translation';
import rules from './pt-rules.translation';

const messages: KatalisTranslation = {
  ...comum,
  ...pages,
  ...routes,
  ...enums,
  ...rules,
};

export default messages;
